import { OrderGroupsModule } from '@/shared';

export default OrderGroupsModule;
